import { ChevronLeftIcon } from "lucide-react"
import { useParams } from "react-router-dom"
import { AppHeader } from "~/components/AppHeader"
import { Link } from "~/components/Link"
import { FormDiscordSettings } from "~/components/forms/FormDiscordSettings"
import { EmptyState, LoadingState } from "~/components/screens/StateScreen"
import { Button } from "~/components/ui/button"
import { usePermission } from "~/hooks/usePermission"
import { useTeam } from "~/hooks/useTeam"
import { TeamPermissions } from "~/lib/permissions"
import { api } from "~/trpc/react"

export default function FormSettingsPage() {
	const { team, orgSlug, isLoading } = useTeam()
	const { formId = "" } = useParams<{ formId: string }>()
	const { hasTeamPermission } = usePermission()
	const form = api.forms.get.useQuery(
		{ teamId: team?.id ?? "", formId },
		{ enabled: !!team?.enableForms && !!formId }
	)
	if (isLoading) return <LoadingState />
	if (!team?.enableForms) return <EmptyState title="Forms are disabled" />
	if (!hasTeamPermission(TeamPermissions.ADMINISTRATOR))
		return <EmptyState title="Administrator permission required" />
	return (
		<main className="flex h-full min-h-0 flex-col">
			<AppHeader contentClassName="flex items-center gap-2">
				<Button variant="ghost" size="icon-md" asChild>
					<Link
						to={`/${orgSlug}/${team.slug}/forms/${formId}`}
						aria-label="Back to form"
					>
						<ChevronLeftIcon />
					</Link>
				</Button>
				<span className="truncate font-medium">
					{form.data?.name ?? "Form"}
				</span>
				<span className="text-text-sub">/</span>
				<span>Settings</span>
			</AppHeader>
			<div className="min-h-0 flex-1 overflow-auto p-4 sm:p-6">
				<div className="max-w-2xl">
					<FormDiscordSettings
						key={`${team.id}:${formId}`}
						teamId={team.id}
						formId={formId}
					/>
				</div>
			</div>
		</main>
	)
}
